import Button from '../Button/Button';
import React, { PropsWithChildren } from 'react';
import Show from '../Show/Show';
import { BasicModalBelowWrapper } from './BasicModalBelowWrapper';
import {  Body1Reg, Title3 } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { SPACING } from '../../config/designSystem/Spacing';
import { TwoButtonsVertical } from '../Button/TwoButtonsVertical';
import { View } from 'react-native';

interface BasicModalWithTwoButtonsProps extends PropsWithChildren {
    onDismiss: () => void;
    onMainAction: () => void;
    mainText: string;
    buttonDismissText?: string;
    buttonMainActionText:string;
    titleText: string;
    isVisible: boolean;
  }

export const Drawer = ({  onDismiss, isVisible, onMainAction, titleText, mainText, buttonDismissText, buttonMainActionText, children}: BasicModalWithTwoButtonsProps) => {

  return (
    <BasicModalBelowWrapper isVisible={isVisible} onDismiss={onDismiss}>
      <View style={{
        rowGap: SPACING['sp-32']
      }}>
        <Show when={!!titleText}>
          <Title3 align={true} color={COLORS.content.primary}>
            {titleText}
          </Title3>
        </Show>
        <Show when={!!mainText}>
          <Body1Reg align={true} color={COLORS.content.secondary}>
            {mainText}
          </Body1Reg>
        </Show>
        <Show when={!!children}>
          <View style={{alignItems:'center'}}>
            {children}
          </View>
        </Show>

        <Show when={!!buttonDismissText} fallback={
          <View style={{alignItems:'center'}}>
            <Button marginBottom={0} smallText={false} onPress={onMainAction} label={buttonMainActionText}/>
          </View>}>
          <TwoButtonsVertical marginBottom={0} smallText={false} onPressBelow={onDismiss} onPressTop={onMainAction} labelBelow={buttonDismissText as string} labelTop={buttonMainActionText}/>
        </Show>
      </View>
    </BasicModalBelowWrapper>
  );
};